export default {
    "backgrounds": [
        {
            "tile": "groundTop",
            "type": "ground",
            "ranges": [
                [
                   0, 125,
                   12, 1
                ],
                [
                   130, 18,
                   10, 1
                ],
                [
                   153, 25,
                   6, 1
                ],
                [
                    0,5,
                    10,1
                ],
                [
                    33, 5,
                    9, 5
                ],
                [
                    202, 20,
                    12, 1
                ],
            ]
        },
       {
            "tile": "groundSoil",
            "type": "ground",
            "ranges": [
                [
                    0, 125,
                    13, 1
                ],
                [
                    130, 18,
                    11, 3
                ],
                [
                    153, 25,
                    7, 7
                ],
                [
                    0, 5,
                    11, 2
                ],
                [
                    33, 5,
                    10, 4
                ],
                [
                    202, 20,
                    13, 1
                ],
            ]
        },
       {
           "tile": "groundTopRightEdge",
            "type": "ground",
            "ranges": [
                [
                    5, 1,
                    10, 1
                ],
                [
                    37, 1,
                    9, 1
                ],
                [
                    78, 1,
                    12, 1
                ],
                [
                    110, 1,
                    12, 1
                ],
                [
                    135, 1,
                    10, 1
                ],
                [
                    145, 1,
                    10, 1
                ],
                [
                    158, 1,
                    6, 1
                ],
                [
                    222, 1,
                    12, 1
                ],
                [
                    177, 1,
                    6, 1
                ],
            ]
        },
       {
           "tile": "groundTopLeftEdge",
            "type": "ground",
            "ranges": [
                [
                    32, 1,
                    9, 1
                ],
                [
                    93, 1,
                    12, 1
                ],
                [
                    130, 1,
                    10, 1
                ],
                [
                    140, 1,
                    10, 1
                ],
                [
                    152, 1,
                    6, 1
                ],
                [
                    162, 1,
                    6, 1
                ],
                [
                    202, 1,
                    12, 1
                ],
            ]
        },
       {
           "tile": "groundMidRightEdge",
            "type": "ground",
            "ranges": [
                [
                    5, 1,
                    11, 1
                ],
                [
                    5, 1,
                    11, 1
                ],
                [
                    37, 1,
                    10, 2   
                ],
                [
                    78, 1,
                    13, 1
                ],
                [
                    110, 1,
                    13, 1
                ],
                [
                    135, 1,
                    11, 1
                ],
                [
                    145, 1,
                    11, 3
                ],
                [
                    158, 1,
                    7, 1
                ],
                [
                    222, 1,
                    13, 1
                ],
                [
                    177, 1,
                    7, 7
                ],
            ]
        },
       {
           "tile": "groundMidLeftEdge",
            "type": "ground",
            "ranges": [
                [
                    32, 1,
                    10, 2
                ],
                [
                    93, 1,
                    13, 1
                ],
                [
                    130, 1,
                    11, 3
                ],
                [
                    140, 1,
                    11, 1
                ],
                [
                    152, 1,
                    7, 7
                ],
                [
                    162, 1,
                    7, 1
                ],
                [
                    202, 1,
                    13, 1
                ],
            ]
        },
       {
           "tile": "groundTopRightPatch",
            "type": "ground",
            "ranges": [
                [
                    5, 1,
                    12, 1
                ],
                [
                    37, 1,
                    12, 1
                ],
                [
                    135, 1,
                    12, 1
                ],
                [
                    158, 1,
                    8, 1
                ],
            ]
        },
       {
           "tile": "groundTopLeftPatch",
            "type": "ground",
            "ranges": [
                [
                    32, 1,
                    12, 1
                ],
                [
                    140, 1,
                    12, 1
                ],
                [
                    162, 1,
                    8, 1
                ],
            ]
        },
        {
            "tile": "groundTopFloatingLeft",
            "type": "floatingPlatform",
            "ranges": [
                [
                    73, 1,
                    8, 1
                ],
                [
                    100, 1,
                    7, 1
                ],
            ]
        },
        {
            "tile": "groundTopFloatingLeft",
            "type": "ground",
            "ranges": [
                [
                    113, 1,
                    6, 1
                ],
            ]
        },
        {
            "tile": "groundTop",
            "type": "floatingPlatform",
            "ranges": [
                [
                    74, 3,
                    8, 1
                ],
                [
                    101, 5,
                    7, 1
                ],
            ]
        },
        {
            "tile": "groundTop",
            "type": "ground",
            "ranges": [
                [
                    114, 10,
                    6, 1
                ],
                [
                    136, 4,
                    12, 1
                ],
                [
                    159, 3,
                    8, 1
                ],
            ]
        },
       {
           "tile": "groundTopFloatingRight",
           "type": "floatingPlatform",
            "ranges": [
                [
                    77, 1,
                    8, 1
                ],
                [
                    106, 1,
                    7, 1
                ],
            ]
        }, 
       {
           "tile": "groundTopFloatingRight",
           "type": "ground",
            "ranges": [
                [
                    124, 1,
                    6, 1
                ],
            ]
        }, 
        {
            "tile": "groundTopFloatingLeftSoil",
            "ranges": [
                [
                    73, 1,
                    9, 3
                ],
                [
                    100, 1,
                    8, 4
                ],
                [
                    113, 1,
                    7, 10
                ],
            ]
        },
        {
            "tile": "groundSoil",
            "ranges": [
                [
                    74, 3,
                    9, 3
                ],
                [
                    101, 5,
                    8, 4
                ],
                [
                    114, 10,
                    7, 10
                ],
            ]
        },
       {
           "tile": "groundTopFloatingRightSoil",
            "ranges": [
                [
                    77, 1,
                    9, 3
                ],
                [
                    106, 1,
                    8, 4
                ],
                [
                    124, 1,
                    7, 10
                ],
            ]
        },

       {
           "tile": "platformMiddle",
        //    "type": "floatingPlatform",
           "type": "ground",
            "ranges": [
                [
                    14, 11,
                    6, 1
                ],
                [
                    82, 1,
                    7, 1
                ],
                [
                    87, 1,
                    7, 1
                ],
                [
                    186, 7,
                    6, 1
                ],
            ]
        },
       {
           "tile": "platformLeft",
        //    "type": "floatingPlatform",
           "type": "ground",
            "ranges": [
                [
                    8, 1,
                    7, 1
                ],
                [
                    13, 1,
                    6, 1
                ],
                [
                    28, 1,
                    7, 1
                ],
                [
                    81, 1,
                    7, 1
                ],
                [
                    86, 1,
                    7, 1
                ],
                [
                    148, 1,
                    8, 1
                ],
                [
                    148, 1,
                    2, 1
                ],
                [
                    185, 1,
                    6, 1
                ],
            ]
        },
       {
           "tile": "platformRight",
        //    "type": "floatingPlatform",
           "type": "ground",
            "ranges": [
                [
                    9, 1,
                    7, 1
                ],
                [
                    25, 1,
                    6, 1
                ],
                [
                    29, 1,
                    7, 1
                ],
                [
                    83, 1,
                    7, 1
                ],               
                [
                    88, 1,
                    7, 1
                ],      
                [
                    149, 1,
                    8, 1
                ],       
                [
                    149, 1,
                    2, 1
                ],       
                [
                    193, 1,
                    6, 1
                ],  
            ]
        },
        {
            "tile": "mysteryBox",
            "type": "box",
            "item": "mushroom",
            "ranges": [
                [
                    19, 1,
                    2, 1
                ]
            ]
        },
        {
            "tile": "grass1",
            "ranges": [
                [
                    7, 1,
                    11, 1
                ],
                [
                    45, 1,
                    11, 1
                ],
                [
                    60, 1,
                    11, 1
                ],
                [
                    96, 1,
                    11, 1
                ],
                [
                    169, 1,
                    5, 1
                ],

            ]
        },
        {
            "tile": "grass2",
            "ranges": [
                [
                    8, 2,
                    11, 1
                ],
                [
                    46, 3,
                    11, 1
                ],
                [
                    61, 3,
                    11, 1
                ],
                [
                    97, 1,
                    11, 1
                ],
                [
                    170, 3,
                    5, 1
                ],

            ]
        },
        // {
        //     "tile": "grass3",
        //     "ranges": [

        //     ]
        // },
        {
            "tile": "grass4",
            "ranges": [
                [
                    10, 1,
                    11, 1
                ],
                [
                    49, 1,
                    11, 1
                ],
                [
                    64, 1,
                    11, 1
                ],
                [
                    98, 1,
                    11, 1
                ],
                [
                    173, 1,
                    5, 1
                ],
            ]
        },
        {
            "tile": "singlePlatform",
            // "type": "floatingPlatform",
            "type": "ground",
            "ranges": [
                [
                    70, 1,
                    9, 1
                ],
                [
                    40, 3,
                    7, 1
                ],
                [
                    47, 3,
                    7, 1
                ],
                [
                    109, 1,
                    9, 1
                ],
                [
                    109, 1,
                    4, 1
                ],
                [
                    137, 1,
                    7, 1
                ],
                [
                    160, 1,
                    3, 1
                ],
                [
                    181, 1,
                    8, 1
                ],
                [
                    196, 1,
                    8, 1
                ],
                [
                    199, 1,
                    10, 1
                ],
            ]
        },
        {
            "tile": "transparent",
            "ranges": [
                [
                    79, 14,
                    12,2
                ],
                [
                    111, 2,
                    12,2
                ],
                [
                    125, 5,
                    12,2
                ],
                [
                    136, 4,
                    10,2
                ],
                [
                    146, 3,
                    10,4
                ],
                [
                    159, 3,
                    6,2
                ],
            ]
        },

    ]
}